import { render, staticRenderFns } from "./SpeakerListView.vue?vue&type=template&id=5c19a4da"
import script from "./SpeakerListView.vue?vue&type=script&lang=js"
export * from "./SpeakerListView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports